// js/custom-element/section/image-with-text/image-with-text-item.js
(function() {
  const init = function() {
    if (!window.customElements.get("image-with-text-item")) {
      var ImageWithTextItem = class extends HTMLElement {
        get index() {
          return [...this.parentNode.children].indexOf(this);
        }
        get selected() {
          return !this.hasAttribute("hidden");
        }
        get hasAttachedImage() {
          return this.hasAttribute("attached-image");
        }
        async transitionToEnter(shouldAnimate = true) {
          this.removeAttribute("hidden");
          const textWrapper = this.querySelector(".image-with-text__text-wrapper"), headings = await window.resolveAsyncIterator(this.querySelectorAll(".image-with-text__content split-lines"));
          const animation = new window.CustomAnimation(new window.SequenceEffect([
            new window.ParallelEffect(headings.map((item, index) => {
              return new window.CustomKeyframeEffect(item, {
                opacity: [0, 0.2, 1],
                transform: ["translateY(100%)", "translateY(0)"],
                clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
              }, {
                duration: 350,
                delay: 120 * index,
                easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
              });
            })),
            new window.CustomKeyframeEffect(textWrapper, { opacity: [0, 1] }, { duration: 300 })
          ]));
          shouldAnimate ? animation.play() : animation.finish();
          return animation.finished;
        }
        async transitionToLeave(shouldAnimate = true) {
          const elements = await window.resolveAsyncIterator(this.querySelectorAll(".image-with-text__text-wrapper, .image-with-text__content split-lines"));
          const animation = new window.CustomAnimation(new window.ParallelEffect(elements.map((item) => {
            return new window.CustomKeyframeEffect(item, { opacity: [1, 0] }, { duration: 200 });
          })));
          shouldAnimate ? animation.play() : animation.finish();
          await animation.finished;
          this.setAttribute("hidden", "");
        }
      };
      window.customElements.define("image-with-text-item", ImageWithTextItem);
    }

    // js/custom-element/section/image-with-text/image-with-text.js
    if (!window.customElements.get("image-with-text")) {
      var ImageWithText = class extends CustomHTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll("image-with-text-item"));
          this.imageItems = Array.from(this.querySelectorAll(".image-with-text__image"));
          this.pageDots = this.querySelector("page-dots");
          this.hasPendingTransition = false;
          if (this.items.length > 1) {
            this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
            if (Shopify.designMode) {
              this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this));
              this.addEventListener("shopify:block:select", (event) => {
                this.intersectionObserver.disconnect();
                this.pausePlayer();
                this.select(event.target.index, !event.detail.load);
              });
            }
          }
          this._setupVisibility();
        }
        async _setupVisibility() {
          await this.untilVisible();
          if (this.hasAttribute("reveal-on-scroll")) {
            await this.transitionImage(this.selectedIndex);
            this.select(this.selectedIndex);
          }
          this.startPlayer();
        }
        get selectedIndex() {
          return this.items.findIndex((item) => item.selected);
        }
        async select(index, shouldAnimate = true) {
          if (this.hasPendingTransition) {
            return;
          }
          this.hasPendingTransition = true;
          if (this.items[index].hasAttachedImage || !shouldAnimate) {
            await this.transitionImage(index, shouldAnimate);
          }
          if (this.selectedIndex !== index) {
            await this.items[this.selectedIndex].transitionToLeave(shouldAnimate);
          }
          if (this.pageDots) {
            this.pageDots.selectedIndex = index;
          }
          await this.items[index].transitionToEnter(shouldAnimate);
          this.hasPendingTransition = false;
        }
        async transitionImage(index, shouldAnimate = true) {
          const activeImage = this.imageItems.find((item) => !item.hasAttribute("hidden")), nextImage = this.imageItems.find((item) => item.id === this.items[index].getAttribute("attached-image")) || activeImage;
          activeImage.setAttribute("hidden", "");
          nextImage.removeAttribute("hidden");
          await window.imageLoaded(nextImage);
          const animation = new window.CustomAnimation(new window.CustomKeyframeEffect(nextImage, {
            visibility: ["hidden", "visible"],
            clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
          }, {
            duration: 600,
            easing: "cubic-bezier(1, 0, 0, 1)"
          }));
          shouldAnimate ? animation.play() : animation.finish();
        }
        pausePlayer() {
          this.style.setProperty("--section-animation-play-state", "paused");
        }
        startPlayer() {
          this.style.setProperty("--section-animation-play-state", "running");
        }
      };
      window.customElements.define("image-with-text", ImageWithText);
    }

    // js/custom-element/section/image-with-text-overlay/image-with-text-overlay.js
    if (!window.customElements.get("image-with-text-overlay")) {
      var ImageWithTextOverlay = class extends CustomHTMLElement {
        connectedCallback() {
          if (this.hasAttribute("parallax") && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            this._hasPendingRaF = false;
            this._onScrollListener = this._onScroll.bind(this);
            window.addEventListener("scroll", this._onScrollListener);
          }
          if (this.hasAttribute("reveal-on-scroll")) {
            this._setupVisibility();
          }
        }
        disconnectedCallback() {
          super.disconnectedCallback();
          if (this._onScrollListener) {
            window.removeEventListener("scroll", this._onScrollListener);
          }
        }
        async _setupVisibility() {
          await this.untilVisible();
          const image = this.querySelector(".image-overlay__image"), headings = await window.resolveAsyncIterator(this.querySelectorAll("split-lines")), prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          await window.imageLoaded(image);
          const innerEffect = [
            new window.CustomKeyframeEffect(image, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }),
            new window.ParallelEffect(headings.map((item, index) => {
              return new window.CustomKeyframeEffect(item, {
                opacity: [0, 0.2, 1],
                transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"],
                clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
              }, {
                duration: 300,
                delay: prefersReducedMotion ? 0 : 120 * index,
                easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
              });
            })),
            new window.CustomKeyframeEffect(this.querySelector(".image-overlay__text-container"), { opacity: [0, 1] }, { duration: 300 })
          ];
          const animation = prefersReducedMotion ? new window.CustomAnimation(new window.ParallelEffect(innerEffect)) : new window.CustomAnimation(new window.SequenceEffect(innerEffect));
          this._hasSectionReloaded ? animation.finish() : animation.play();
        }
        _onScroll() {
          if (this._hasPendingRaF) {
            return;
          }
          this._hasPendingRaF = true;
          requestAnimationFrame(() => {
            const boundingRect = this.getBoundingClientRect(), speedFactor = 3, contentElement = this.querySelector(".image-overlay__content-wrapper"), imageElement = this.querySelector(".image-overlay__image"), boundingRectBottom = boundingRect.bottom, boundingRectHeight = boundingRect.height, stickyHeaderOffset = window.getStickyHeaderOffset();
            if (contentElement) {
              contentElement.style.opacity = Math.max(1 - speedFactor * (1 - Math.min(boundingRectBottom / boundingRectHeight, 1)), 0).toString();
            }
            if (imageElement) {
              imageElement.style.transform = `translateY(${100 - Math.max(1 - (1 - Math.min(boundingRectBottom / (boundingRectHeight + stickyHeaderOffset), 1)), 0) * 100}px)`;
            }
            this._hasPendingRaF = false;
          });
        }
      };
      window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
    }

    // js/custom-element/section/image-with-text-block/image-with-text-block.js
    if (!window.customElements.get("image-with-text-block")) {
      var ImageWithTextBlock = class extends CustomHTMLElement {
        async connectedCallback() {
          if (this.hasAttribute("reveal-on-scroll")) {
            this._setupVisibility();
          }
        }
        async _setupVisibility() {
          await this.untilVisible();
          const images = Array.from(this.querySelectorAll(".image-with-text-block__image[reveal]")), headings = await window.resolveAsyncIterator(this.querySelectorAll("split-lines")), prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          for (const image of images) {
            if (image.offsetParent !== null) {
              await window.imageLoaded(image);
            }
          }
          const innerEffect = [
            new window.ParallelEffect(images.map((item) => {
              return new window.CustomKeyframeEffect(item, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" });
            })),
            new window.CustomKeyframeEffect(this.querySelector(".image-with-text-block__content"), { opacity: [0, 1], transform: [`translateY(${prefersReducedMotion ? 0 : "60px"})`, "translateY(0)"] }, { duration: 150, easing: "ease-in-out" }),
            new window.ParallelEffect(headings.map((item, index) => {
              return new window.CustomKeyframeEffect(item, {
                opacity: [0, 0.2, 1],
                transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"],
                clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
              }, {
                duration: 300,
                delay: prefersReducedMotion ? 0 : 120 * index,
                easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
              });
            })),
            new window.CustomKeyframeEffect(this.querySelector(".image-with-text-block__text-container"), { opacity: [0, 1] }, { duration: 300 })
          ];
          const animation = prefersReducedMotion ? new window.CustomAnimation(new window.ParallelEffect(innerEffect)) : new window.CustomAnimation(new window.SequenceEffect(innerEffect));
          this._hasSectionReloaded ? animation.finish() : animation.play();
        }
      };
      window.customElements.define("image-with-text-block", ImageWithTextBlock);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();